import { render, staticRenderFns } from "./ClientIcon.vue?vue&type=template&id=fae1a236&scoped=true&"
var script = {}
import style0 from "./ClientIcon.vue?vue&type=style&index=0&id=fae1a236&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae1a236",
  null
  
)

export default component.exports